import { render, staticRenderFns } from "./BuktiGadai.vue?vue&type=template&id=13e63c2c&scoped=true&"
import script from "./BuktiGadai.vue?vue&type=script&lang=js&"
export * from "./BuktiGadai.vue?vue&type=script&lang=js&"
import style0 from "./BuktiGadai.vue?vue&type=style&index=0&id=13e63c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e63c2c",
  null
  
)

export default component.exports